import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import calendarPageImage from '../assets/images/calendar_page_full.png';
import homePageImage from '../assets/images/home_page_full.png';
import CtaButton from './atoms/Button/CTAButton';
const Hero = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "flex min-h-[66.67vh] items-center justify-center bg-teal-700 p-8 text-center text-white md:text-left",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full max-w-6xl flex-col items-center justify-between gap-8 md:flex-row",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "mb-6 text-6xl font-bold tracking-wider md:text-7xl",
                            style: {
                                fontFamily: "'Caveat', cursive"
                            },
                            children: "Histotime"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-12 text-2xl opacity-90 md:text-3xl",
                            children: "不定期に起きるから、記録が頼りになる。"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-12 text-lg leading-relaxed opacity-95 md:text-xl",
                            children: [
                                "Histotimeは、薬の服用や体調の変化など",
                                /*#__PURE__*/ _jsx("br", {}),
                                "不定期に起きることを、ワンタップで記録できる",
                                /*#__PURE__*/ _jsx("br", {}),
                                "シンプルな記録管理アプリです。"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(CtaButton, {
                            align: "left"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative flex items-end justify-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "relative z-10 w-40 md:w-64",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: homePageImage,
                                alt: "Histotime ホーム画面",
                                className: "h-auto w-full"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "-ml-4 w-36 md:-ml-6 md:w-60",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: calendarPageImage,
                                alt: "Histotime カレンダー画面",
                                className: "h-auto w-full"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
export default Hero;
